import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class MessageService {
	data: object;

	sendMessage(data: object) {
		this.data = data;
	}

	clearMessages() {
		this.data = null;
	}
}
